import type { App as VueApp } from "vue";
import type { Router } from "vue-router";
import { abilitiesPlugin } from "@casl/vue";
import vClickOutside from "click-outside-vue3";

import i18n from "@/localization/i18n";
import { useEtcAbility } from "@/common/ability";
import permissionPlugin from "@/plugins/permissionPlugin";
import vFocus from "@/directives/vFocus";
import { pinia } from "@/stores";

export function setupAppPlugins(app: VueApp, router: Router): void {
  app.use(i18n);
  app.use(pinia);
  app.use(router);

  app.use(abilitiesPlugin, useEtcAbility(), {
    useGlobalProperties: true,
  });

  app.use(permissionPlugin);
  app.use(vClickOutside);

  app.directive("focus", vFocus);
}
